import React from 'react';
import HeaderSimplePage from 'Components/HeaderMobile/SimplePage';
import EnvironmentManager from '../../../utils/environmentManager';

const About = () => {
  const aboutUsText = EnvironmentManager.getMessageText({ key: 'new_about_us_text' });
  return (
    <>
      <HeaderSimplePage color="green" title="Hakkımızda"/>
      <div className="page page--user-agreement">

        <div  className="page__content" dangerouslySetInnerHTML={ { __html: aboutUsText } }/>
      </div>
    </>
  );
};

export default About;
